import React from 'react';
import { useCurrency } from '../context/CurrencyContext';

const OPTIONS = ['SAR', 'USD'];

// variant: 'light' (storefront, on blush bg) | 'admin' (on white)
export function CurrencySwitcher({ variant = 'light', className = '' }) {
    const { currency, setCurrency } = useCurrency();
    const border = variant === 'admin' ? 'rgba(90,36,50,0.14)' : 'rgba(94,33,52,0.20)';

    return (
        <div
            role="group"
            aria-label="Select currency"
            data-testid="currency-switcher"
            className={`inline-flex items-center rounded-full p-0.5 ${className}`}
            style={{ border: `1px solid ${border}`, backgroundColor: variant === 'admin' ? '#fff' : 'rgba(255,255,255,0.5)' }}
        >
            {OPTIONS.map((opt) => {
                const active = currency === opt;
                return (
                    <button
                        key={opt}
                        type="button"
                        onClick={() => setCurrency(opt)}
                        data-testid={`currency-option-${opt.toLowerCase()}`}
                        aria-pressed={active}
                        className="px-2.5 py-1 rounded-full text-[11px] font-medium tracking-[0.08em] transition-colors"
                        style={active
                            ? { backgroundColor: 'var(--brand-burgundy, #5A2432)', color: '#fff' }
                            : { color: 'var(--brand-burgundy, #5A2432)', backgroundColor: 'transparent' }}
                    >
                        {opt}
                    </button>
                );
            })}
        </div>
    );
}
